export enum CONDITION_TYPE {
    basic = 'basic_condition',
    page = 'page_condition',
    url = 'url_param_condition',
    native = 'native_app_condition'
}

export enum TAG_TYPE {
    customHtml = 'custom_tag_type',
    customJs = 'custom_js',
    dynamicClientType = 'dynamic_client_type',
    dynamicYield = 'dynamic_yield',
    evolutionGames = 'evolution_games',
    ezPush = 'ez_push',
    userFlowBuilder = 'user_flow_builder',
    ipWhiteList = 'ip_white_list',
    geoComply = 'geocomply',
    geofencing = 'geofencing',
    googleTagManager = 'google_tag_manager',
    ucip = 'ucip',
    caf = 'caf'
}

export enum BASIC_TAG_LAUNCH_CONDITION {
    beforePageRendered = 'beforePageRendered',
    afterPageRendered = 'afterPageRendered',
    onAppInit = 'onAppInit',
    onWrapperInit = 'onWrapperInit'
}

export enum URL_TAG_LAUNCH_CONDITION {
    nonParamsPresent = '0',
    allParamsPresent = '1'
}

export enum NATIVE_TAG_LAUNCH_CONDITION {
    nonNativeApp = '0',
    nativeAppOnly = '1'
}

export const CONDITION_GROUPS = {
    // triggered on event
    regular: [
        CONDITION_TYPE.basic
    ],
    // triggered every time with regular
    additional: [
        CONDITION_TYPE.url,
        CONDITION_TYPE.page,
        CONDITION_TYPE.native
    ]
};
